
import { defineComponent, inject } from 'vue';
import MaterialIcon from '@/components/MaterialIcon.vue';
import { InjectionKeys } from '@/constants';

export default defineComponent({
  name: 'MaterialIconButton',
  components: {
    MaterialIcon
  },
  props: {
    inverted: {
      type: Boolean
    }
  },
  setup() {
    const setDirty = inject(InjectionKeys.SetFormDirty);

    return {
      setDirty
    };
  }
});
